import Loader from 'app/components/shared/app/Loader';
import Constants from 'app/lib/Constants';
import React, { useState } from 'react';
import "./style.scss";

const Answers = () => {
    const [loading, setLoading] = useState(true);

    const onLoaded = async (e) => {
        console.log(`loaded.`)
        setLoading(false);
    }
    return (
        <div className="answers-page">

            {loading && <div className="loader"><Loader /></div>}

            <iframe src={Constants.ANSWER_CLOUD_URL} frameBorder="0" onLoad={onLoaded} />

        </div>
    )
}

export default Answers;